import { Box as BoxMui } from '@mui/material';

const Box = (props) => {
    return (
        <BoxMui {...props} />
    )
}

export default Box;